import { render, staticRenderFns } from "./HotRanksV2.vue?vue&type=template&id=c4fa8642&scoped=true&"
import script from "./HotRanksV2.vue?vue&type=script&lang=ts&"
export * from "./HotRanksV2.vue?vue&type=script&lang=ts&"
import style0 from "./HotRanksV2.vue?vue&type=style&index=0&id=c4fa8642&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fa8642",
  null
  
)

export default component.exports